(function ($) {
  DJ.addBehavior('mailboxBack', '.mailbox', {
    attach: function () {
      const mailbox = this;
      const mailboxListItem = mailbox.querySelector('.mail-list-item');

      /**
       * If on the page no list item - return false.
       */
      if (!mailboxListItem) {
        return false;
      }

      /**
       * On 'pageshow' reload the page if the user came using the back browser button.
       */
      window.addEventListener('pageshow', function (event) {
        const historyTraversal = event.persisted
          || (typeof window.performance !== 'undefined'
            && window.performance.getEntriesByType('navigation').length
            && window.performance.getEntriesByType('navigation')[0].type === 'back_forward');

        if (historyTraversal) {
          window.location.reload();
        }
      });

      return true;
    }
  });
})(jQuery);
